export default __webpack_public_path__ + "static/biliyana-27e6ddbc5417928b01cd76bfe0c30866.png";